/**
 * 指定した条件に合致した掲載商品データを取得する際のVO(掲載商品検索機能:KYMW1403で用いる)
 *
 * @export PublishGoodsDataModel
 * @class PublishGoodsDataModel
 */
export class PublishGoodsDataModel {
  /**
   * 画面ID
   */
  public formID = String('');

  /**
   * 受注コード(From)
   */
  public orderCodeFrom = String('');

  /**
   * 受注コード(To)
   */
  public orderCodeTo = String('');

  /**
   * 商品案内用商品名
   */
  public guideGoodsName = String('');

  /**
   * Pコード
   */
  public pCode = String('');

  /**
   * 会員生協（茨城）チェック
   */
  public coopIbarakiChk = String('0');

  /**
   * 会員生協（栃木）チェック
   */
  public coopTochigiChk = String('0');

  /**
   * 会員生協（群馬）チェック
   */
  public coopGunmaChk = String('0');

  /**
   * 会員生協（千葉）チェック
   */
  public coopChibaChk = String('0');

  /**
   * 会員生協（埼玉）チェック
   */
  public coopSaitamaChk = String('0');

  /**
   * 会員生協（東京）チェック
   */
  public coopTokyoChk = String('0');

  /**
   * 会員生協（長野）チェック
   */
  public coopNaganoChk = String('0');

  /**
   * 会員生協（新潟）チェック
   */
  public coopNiigataChk = String('0');

  /**
   * 会員生協（クルコ）チェック
   */
  public coopKurucoChk = String('0');

  /**
   * ソート指定項目
   */
  public sortItem = String('');

  /**
   * 昇順降順
   */
  public sortOrder = String('');

  /**
   * 取得対象ページ
   */
  public page = Number(1);

  /**
   * コンストラクタ
   *
   */
  constructor() {
    // 画面IDを設定
    this.formID = 'KYMW1403';
  }
}
